import { getGameListByJumpList } from "@/lobby_common/api/basic_gen.js";
import {
  getGameOtherInfo,
  getJumpBindGameCount,
} from "@/lobby_common/api/game_gen.js";
import zanwu from "@/assets/new/zanwu.png";
import hideGmae from "@/lobby_common/mixins/hideGmae.js";
import { gameImg } from "@/lobby_common/utils/img.js";
import GameHot from "@/components/game/h-hot";
import { mapGetters } from "vuex";
import { debounce, formattedValue } from "@/lobby_common/utils/index.js";
import gameItem from "@/components/game/game-item";
import { divideAccuracy, fadeInAnimate } from "@/lobby_common/utils/utils.js";
export default {
  mixins: [hideGmae],
  name: "homeSearch",
  components: {
    GameHot,
    gameItem,
  },
  data() {
    return {
      formattedValue,
      zhanwutype: false,
      gameImg,
      zanwu: zanwu,
      current: undefined,
      keyword: undefined,
      select: [],
      pcList: [],
      isMore: false, // 是否显示加载更多
      page: 1,
      currGameId: null,
      cur_Menu_Info: {},
      h5_Cur_Manufacturer: {},
      tabList: [],
      retop: 0,
      cur_params: {},
      showGameHot: false,
      brandGroupGameList: [],
      brandGroupList: [],
      tagList: [],
      playList: [],
      intervalId: null,
      updateInterval: 5000,
      loading: false,
      gameForm: {
        brandGroupSid: undefined,
        gameTagSid: undefined,
        gamePlayTypeSid: undefined,
        gameGroupName: undefined,
        sortType: "GAME_SORT_TYPE_DEFAULT",
      },
    };
  },
  computed: {
    list() {
      return this.pcList.map((item, i) => {
        return {
          ...item,
          currentValue: this.formattedValue(item.currentValue),
          eid: `106_0_0_${i + 1}_${item.gameGroupSid}`,
          oid: `106_0_0_${i + 1}`,
        };
      });
    },
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    lang() {
      return this.$store.getters.getLang;
    },
    sortTypes() {
      return [
        {
          label: this.$t("Datalang.home_Popular"),
          value: "GAME_SORT_TYPE_DEFAULT",
        },
        {
          label: "A-Z",
          value: "GAME_SORT_TYPE_ASC",
        },
        {
          label: "Z-A",
          value: "GAME_SORT_TYPE_DESC",
        },
      ];
    },
    ...mapGetters(["getIsMobile"]),
    coin_accuracy() {
      return this.$store.getters.getPacketConfig?.appConfig?.accuracy
        ? this.$store.getters.getPacketConfig?.appConfig?.accuracy
        : 2;
    },
    accuracy() {
      return this.$store.getters.getCurCoin?.accuracy || this.coin_accuracy;
    },
    packetConfig() {
      return this.$store.getters.getPacketConfig?.packetInfo?.baseInfo || {};
    },
    gameShow() {
      return this.packetConfig.gameNameShowPosition !== 4;
    },
    jp_show() {
      return this.packetConfig.gameIconShowJp === "ROW_STATUS_ENABLE";
    },
  },
  created() {},
  watch: {},
  mounted() {
    // console.log('4444444444')
    const that = this;
    that.cur_params = localStorage.getItem("Cur_params")
      ? JSON.parse(localStorage.getItem("Cur_params"))
      : {};
    that.getGamelistFun();
    // this.getTags();
    this.getbrandGroupGameList();
  },
  beforeRouteUpdate() {
    // console.log("555555555");
    this.gameForm = {};
    this.cur_params = localStorage.getItem("Cur_params")
      ? JSON.parse(localStorage.getItem("Cur_params"))
      : {};
    this.getGamelistFun();
    // this.getTags();
  },
  beforeDestroy() {
    // console.log("6666666");
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    getIconMap(obj = {}, flag = 1) {
      const unSelectSrc = this.$utils.returnImgUrl(obj.iconUnselected);
      const selectSrc = this.$utils.returnImgUrl(obj.icon);
      const iconSmall = obj.iconSmall
        ? this.$utils.returnImgUrl(obj.iconSmall)
        : selectSrc;
      const map = {
        1: unSelectSrc,
        2: selectSrc,
        3: iconSmall,
      };
      return map[flag];
    },
    // 动画效果
    async gameAnimate() {
      this.retop = 300;
      let div = "";
      const scrollWrap = this.$refs.scrollWrap?.$el;
      if (this.$refs.contentWrap1) {
        div = this.$refs.contentWrap1;
      }
      if (this.$refs.contentWrap2) {
        div = this.$refs.contentWrap2;
      }
      if (div) {
        if (scrollWrap) {
          scrollWrap.scrollTo({ top: 0 });
        }
        div.style.transition = "none";
        this.timer = setTimeout(() => {
          div.style.transform = "translateZ(0)";
          div.style.transition = "top 0.3s";
          this.retop = 0;
          this.showGameHot = true;
        }, 200);
      } else {
        this.showGameHot = true;
      }
    },
    // 获取游戏标签
    async getTags() {
      const { code, data } = await getGameOtherInfo({
        // tag_type: 1,
        // bindType: this.cur_params.bindType || 2,
        // menu_id: Number(this.cur_params.id),
      });
      if (code === 0) {
        this.brandGroupList = data?.brandGroupList || []; // 厂商组
        this.tagList = data.tagList || []; // 标签
        this.playList = data.playList || []; // 玩法
      }
    },
    // 品牌游戏数量
    async getbrandGroupGameList() {
      let jumpSid;
      if (this.cur_params.bindType === 1) {
        jumpSid = this.cur_params.jump.multipleGame.sid;
      }
      if (this.cur_params.bindType === 2) {
        jumpSid = this.cur_params.list[0]?.jump.multipleGame.sid;
      }
      if (this.cur_params.bindType === 3) {
        jumpSid = this.cur_params.jump.multipleGame.sid;
      }
      const { code, data } = await getJumpBindGameCount({
        jumpBindGameSid: jumpSid,
      });
      if (code === 0) {
        this.brandGroupGameList = data?.list || []; // 厂商组
      }
    },
    keyWordFun: debounce(function () {
      this.pcList = [];
      this.getGamelistFun();
    }, 200),
    async getGamelistFun(page = 1, isClickCollection = false) {
      // console.log("getGamelistFun", page);
      this.pcList = [];
      this.showGameHot = false;
      this.page = page;
      this.zhanwutype = false;
      const obj = { ...this.gameForm };
      obj.brandGroupSid = obj.brandGroupSid || undefined;
      obj.gameTagSid = obj.gameTagSid || undefined;
      obj.gamePlayTypeSid = obj.gamePlayTypeSid || undefined;
      // const { menuId, manufacturerId } = this.$route.params;
      let jumpSid, templateType, templateSid;
      if (this.cur_params.bindType === 1) {
        jumpSid = this.cur_params.jump.multipleGame.sid;
        templateType = "menu";
        templateSid = this.cur_params.sid;
      }
      if (this.cur_params.bindType === 2) {
        jumpSid = this.cur_params.list[0]?.jump.multipleGame.sid;
        templateType = "home";
      }
      if (this.cur_params.bindType === 3) {
        jumpSid = this.cur_params.jump.multipleGame.sid;
        templateType = "home";
      }
      if (this.cur_params.bindType === 4) {
        jumpSid = this.cur_params.jump.multipleGame.sid;
        templateType = "bottom";
      }

      // 找不到跳转id时 跳转首页
      if (!jumpSid) {
        this.$router.push("/home");
        return false;
      }

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
      });
      const { code, data } = await getGameListByJumpList({
        page: page || 1,
        pageSize: 42,
        jumpSid: jumpSid,
        templateType: templateType,
        templateSid: templateSid,
        // gameGroupName: this.keyword && this.keyword.trim(),
        ...obj,
      });
      if (code === 0) {
        const games = data?.gameList || [];
        games.forEach((item) => {
          if (item.jpInfo && item.jpInfo.jpValue > 0) {
            item.jpInfo.jpValue = divideAccuracy(
              item.jpInfo.jpValue,
              this.accuracy
            );
            item.jpInfo.updateTime = Number(item.jpInfo.updateTime);
          } else {
            item.jpInfo = {
              jpValue: 0,
              updateTime: 0,
            };
          }
          if (data?.isRecommend) {
            // 开启了千人千面
            item.isRecommend = true;
          }
          item.finalValue = item.jpInfo.jpValue;
          item.initiaValue = item.finalValue * 0.8;
          item.currentValue = this.offsetTimeValue(item);
        });
        this.pcList = games;
        // this.pcList = [...new Set([...(data?.gameList || [])])];
        if (this.jp_show && this.gameShow) {
          this.startIncrement();
        }
        this.zhanwutype = true;
        this.isMore =
          data?.gameList &&
          data?.gameList.length > 0 &&
          data?.gameList.length === 42;
        if (isClickCollection !== true) {
          this.$nextTick(() => {
            // this.gameAnimate();
            // 上滑动画改为淡入动画
            let dom = "";
            if (this.$refs.contentWrap1) {
              dom = this.$refs.contentWrap1;
            }
            if (this.$refs.contentWrap2) {
              dom = this.$refs.contentWrap2;
            }
            fadeInAnimate(dom);
          });
        } else {
          this.showGameHot = true;
        }
        // 移动端加载更多
        if (this.getIsMobile) {
          this.$nextTick(() => {
            this.observer = new IntersectionObserver(this.handleIntersection, {
              rootMargin: "100px", // 提前触发
              threshold: 0.1, // 元素进入 10% 时触发
            });
            const element = document.querySelector("#moreBtnBox");
            if (element) {
              this.observer.observe(element);
            }
          });
        }
      }
      loading.close();
    },
    // 游戏一个一个出来
    getAnimationDelay(i) {
      const num = i % 42;
      return num * 0.02 + "s";
    },
    async getGamelistFunMore(page = 1) {
      this.page = page;
      // const { menuId, manufacturerId } = this.$route.params;
      const obj = { ...this.gameForm };
      obj.brandGroupSid = obj.brandGroupSid || undefined;
      obj.gameTagSid = obj.gameTagSid || undefined;
      obj.gamePlayTypeSid = obj.gamePlayTypeSid || undefined;
      let jumpSid, templateType, templateSid;
      if (this.cur_params.bindType === 1) {
        jumpSid = this.cur_params.jump.multipleGame.sid;
        templateType = "menu";
        templateSid = this.cur_params.sid;
      }
      if (this.cur_params.bindType === 2) {
        jumpSid = this.cur_params.list[0]?.jump.multipleGame.sid;
        templateType = "home";
      }
      if (this.cur_params.bindType === 3) {
        jumpSid = this.cur_params.jump.multipleGame.sid;
        templateType = "home";
      }
      if (this.cur_params.bindType === 4) {
        jumpSid = this.cur_params.jump.multipleGame.sid;
        templateType = "bottom";
      }

      this.loading = true;
      const { code, data } = await getGameListByJumpList({
        page: page || 1,
        pageSize: 42,
        jumpSid: jumpSid,
        templateType: templateType,
        templateSid: templateSid,
        // gameGroupName: this.keyword && this.keyword.trim(),
        ...obj,
      });
      if (code === 0) {
        const games = data?.gameList || [];
        games.forEach((item) => {
          if (item.jpInfo && item.jpInfo.jpValue > 0) {
            item.jpInfo.jpValue = divideAccuracy(
              item.jpInfo.jpValue,
              this.accuracy
            );
            item.jpInfo.updateTime = Number(item.jpInfo.updateTime);
          } else {
            item.jpInfo = {
              jpValue: 0,
              updateTime: 0,
            };
          }
          if (data?.isRecommend) {
            // 开启了千人千面
            item.isRecommend = true;
          }
          item.finalValue = item.jpInfo.jpValue;
          item.initiaValue = item.finalValue * 0.8;
          item.currentValue = this.offsetTimeValue(item);
        });
        this.pcList = [...new Set([...this.pcList, ...games])];
        // this.pcList = [...new Set([...this.pcList, ...(data.gameList || [])])];
        if (this.jp_show && this.gameShow) {
          this.startIncrement();
        }
        this.isMore =
          data?.gameList &&
          data?.gameList.length > 0 &&
          data?.gameList.length === 42;
      }
      this.loading = false;
    },
    moreFun() {
      if (this.loading) return false;
      this.getGamelistFunMore(this.page + 1);
    },
    startIncrement() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        this.pcList = this.pcList.map((item) => {
          // const minIncrement = item.finalValue * 0.01;
          const maxIncrement = item.finalValue * 0.0005;

          if (item.currentValue < item.finalValue * 0.95) {
            // const randomIncrement = Math.random() * (maxIncrement - minIncrement) + minIncrement;

            item.currentValue += maxIncrement;

            if (item.currentValue > item.finalValue * 0.95) {
              item.currentValue = item.finalValue;
            }
          } else {
            item.currentValue = item.initiaValue;
          }
          return item;
        });
      }, this.updateInterval);
    },
    // 计算差值
    offsetTimeValue(item) {
      const jpInfo = item.jpInfo;
      if (!jpInfo.jpValue || jpInfo.jpValue < 1 || jpInfo.updateTime < 1) {
        return jpInfo.jpValue;
      }
      // 计算时间差值 (当前时间-数据更新时间) / 1000 * 每秒更新值
      const offset =
        ((Date.now() - jpInfo.updateTime) / 5000) * (jpInfo.jpValue * 0.0005);
      let currentValue = jpInfo.jpValue * 0.8 + offset;

      if (currentValue > jpInfo.jpValue * 0.95) {
        currentValue = jpInfo.jpValue * 0.8;
      }

      return currentValue;
    },
    isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    handleIntersection(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (this.isMore) {
            this.moreFun();
          } else {
            observer.unobserve(entry.target); // 停止观察
          }
        }
      });
    }
  },
  destroyed() {},
};
